import { render, staticRenderFns } from "./InputSigarusTextarea.vue?vue&type=template&id=09094452&"
import script from "./InputSigarusTextarea.vue?vue&type=script&lang=js&"
export * from "./InputSigarusTextarea.vue?vue&type=script&lang=js&"
import style0 from "./InputSigarusTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports